import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="max-one-aktiv-switch"
export default class extends Controller {
	// Den Switcher-Checkboxen change Event hinzufügen
	connect() {
		this.switcherCheckBoxen = this.element.querySelectorAll("input[type='checkbox'].sr-only")
		this.switcherCheckBoxen.forEach((checkbox) => {
			checkbox.dataset.action = `${checkbox.dataset.action} change->max-one-aktiv-switch#maxOneCheck`
		})
	}

	// Wenn eine Checkbox aktiviert wird, müssen alle anderen aktiven Checkboxen deaktiviert werden
	maxOneCheck({ currentTarget }) {
		if (currentTarget.checked) {
			const aktiveCheckBoxen = Array.from(this.switcherCheckBoxen).filter((box) => box != currentTarget && box.checked)
			aktiveCheckBoxen.forEach((box) => this.deaktiviereCheckbox(box))
		}
	}

	// private

	deaktiviereCheckbox(checkbox) {
		const switcher = checkbox.parentNode.querySelector("button[role='switch']")
		switcher.dispatchEvent(new Event("click"))
	}
}
